import InfoPOGMassiveUpload from './containers/InfoPOGMassiveUpload';

export default InfoPOGMassiveUpload;
